import { HELPER_ID_RE, newOwnerKey } from '@notlost/shared';

/**
 * Anonymous helper card. A random secret in this browser only; the server
 * stores its hash and a points tally. Clearing site data starts a new card.
 */
const KEY = 'notlost.helper';

export function getHelperId(create: boolean): string | null {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing && HELPER_ID_RE.test(existing)) return existing;
    if (!create) return null;
    const id = newOwnerKey();
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    return null;
  }
}

/** True when this browser holds the owner key for the tag: no points for scanning your own tag. */
export function ownsTag(tagId: string): boolean {
  try {
    return localStorage.getItem(`notlost.owner.${tagId}`) !== null;
  } catch {
    return false;
  }
}
